import axios from 'axios'
import store from '../store'
import { Message } from 'element-ui'
import router from '../router'

const request = axios.create({
  baseURL: '/api',
  timeout: 15000
})

/** 并发 401 只提示 / 跳转一次，避免落地页连弹多个「登录已过期」 */
let handling401 = false

function isPublicPath(path) {
  return path === '/' || path === '/login' || path === '/register'
}

function handleUnauthorized() {
  if (handling401) return
  handling401 = true
  const onPublic = isPublicPath(router.currentRoute.path)
  store.commit('LOGOUT')
  if (!onPublic) {
    Message.error('登录已过期，请重新登录')
    router.push('/').catch(() => {})
  }
  setTimeout(() => {
    handling401 = false
  }, 2500)
}

request.interceptors.request.use(
  config => {
    if (store.state.token) {
      config.headers['Authorization'] = 'Bearer ' + store.state.token
    }
    return config
  },
  error => Promise.reject(error)
)

request.interceptors.response.use(
  response => {
    // 文件下载（blob）直接返回
    if (response.config.responseType === 'blob') {
      return response
    }
    const res = response.data
    if (res.code && res.code !== 200) {
      // 少数网关可能把业务 401 放在 200 响应体里
      if (res.code === 401) {
        handleUnauthorized()
        return Promise.reject(new Error(res.msg || '登录已过期'))
      }
      Message.error(res.msg || '请求失败')
      return Promise.reject(new Error(res.msg || 'Error'))
    }
    return res
  },
  error => {
    if (error.response) {
      if (error.response.status === 401) {
        handleUnauthorized()
      } else {
        Message.error(error.response.data?.msg || error.message || '网络错误')
      }
    } else {
      Message.error(error.message || '网络错误')
    }
    return Promise.reject(error)
  }
)

export default request
